const services = [
  {
    icon: "ri-settings-3-line",
    title: "배관막힘 / 역류시공",
    subtitle: "(뚫음, 교체)",
    tags: ["변기", "하수구", "싱크대", "세면대", "세탁실", "베란다", "욕조"],
    img: "https://public.readdy.ai/ai/img_res/4853c7c8de29457745e39662b880dca8.jpg",
  },
  {
    icon: "ri-search-eye-line",
    title: "누수탐지 / 진단시공 / 방수공사",
    subtitle: "(방수, 코킹)",
    tags: ["난방배관", "상수도", "온수배관", "화장실방수", "옥상방수", "유가방수"],
    img: "https://readdy.ai/api/search-image?query=water%20pipe%20leaking%20spray%20burst%20close%20up%2C%20plumber%20hands%20fixing%20pipe%20wrench%2C%20water%20splashing%2C%20dark%20industrial%20background%2C%20emergency%20plumbing%20repair%2C%20realistic%20photo&width=600&height=400&seq=svc_new002&orientation=landscape",
  },
  {
    icon: "ri-bubble-chart-line",
    title: "배관 청소",
    subtitle: "(고압세척, 악취제거)",
    tags: ["하수배관", "싱크대", "변기", "내시경", "스케일링", "관로탐지"],
    img: "https://readdy.ai/api/search-image?query=high%20pressure%20pipe%20cleaning%20sewer%20drain%20manhole%2C%20industrial%20vacuum%20hose%20equipment%2C%20worker%20in%20safety%20vest%2C%20dark%20asphalt%20road%20background%2C%20realistic%20professional%20photo&width=600&height=400&seq=svc_new003&orientation=landscape",
  },
  {
    icon: "ri-tools-line",
    title: "신규설치 / 준설시공",
    subtitle: "(수전설치, 배관공사)",
    tags: ["보강작업", "오수정", "정화조", "배관확장", "하수관로"],
    img: "https://readdy.ai/api/search-image?query=new%20metal%20pipe%20fittings%20installation%20close%20up%2C%20shiny%20stainless%20steel%20pipe%20connectors%2C%20professional%20plumbing%20hardware%2C%20dark%20background%2C%20industrial%20setting%2C%20detailed%20realistic%20photo&width=600&height=400&seq=svc_new004&orientation=landscape",
  },
  {
    icon: "ri-exchange-line",
    title: "각종 설비교체 / 수리",
    subtitle: "(수전교체)",
    tags: ["싱크대", "양변기", "소변기", "밸브교체", "수전교체", "배관교체"],
    img: "https://readdy.ai/api/search-image?query=construction%20worker%20excavation%20outdoor%20pipe%20replacement%2C%20workers%20digging%20ground%20installing%20underground%20pipes%2C%20orange%20safety%20vest%2C%20realistic%20site%20photo&width=600&height=400&seq=svc_new005&orientation=landscape",
  },
  {
    icon: "ri-temp-cold-line",
    title: "동파 / 해빙",
    subtitle: "(언 수도 녹임)",
    tags: ["동파방지", "수도얼음", "해빙", "계량기", "배수구"],
    img: "https://readdy.ai/api/search-image?query=frozen%20water%20pipe%20repair%20thawing%2C%20corroded%20old%20pipe%20close%20up%2C%20rust%20texture%2C%20cold%20winter%20pipe%20freeze%20burst%2C%20realistic%20industrial%20photo%2C%20dark%20background&width=600&height=400&seq=svc_new006&orientation=landscape",
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-14 lg:py-24 bg-zinc-50">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="mb-10 lg:mb-14">
          <span className="inline-block text-blue-500 font-bold text-xs lg:text-sm tracking-widest uppercase mb-2 lg:mb-3">Service Offerings</span>
          <h2 className="text-2xl lg:text-4xl font-black text-zinc-900 max-w-2xl leading-tight">
            다수의 경험과 노하우로<br />전문 서비스를 제공합니다.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-7">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="bg-white rounded-2xl overflow-hidden border border-zinc-100 hover:border-blue-300 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-full h-40 lg:h-52 overflow-hidden">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 lg:p-6">
                <div className="w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center bg-blue-100 text-blue-500 rounded-lg mb-2 lg:mb-3">
                  <i className={`${svc.icon} text-lg lg:text-xl`} />
                </div>
                <h3 className="text-zinc-900 font-bold text-base lg:text-lg leading-snug">
                  {svc.title}
                  <span className="text-zinc-500 font-normal text-sm lg:text-base ml-1">{svc.subtitle}</span>
                </h3>
                <div className="mt-2 lg:mt-3 flex flex-wrap gap-1 lg:gap-1.5">
                  {svc.tags.map((tag) => (
                    <span key={tag} className="text-blue-500 text-xs font-medium">
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="mt-10 lg:mt-14 bg-zinc-900 rounded-2xl px-5 lg:px-8 py-7 lg:py-10 flex flex-col lg:flex-row items-center justify-between gap-5 lg:gap-6">
          <div>
            <div className="text-blue-400 font-bold text-xs lg:text-sm mb-1 lg:mb-2">24시간 · 연중무휴</div>
            <h3 className="text-white text-xl lg:text-2xl font-black">지금 바로 전화 한 통이면 충분합니다</h3>
            <p className="text-zinc-400 text-xs lg:text-sm mt-1">출동 전 전화 상담 100% 무료 · 서울·경기 전지역</p>
          </div>
          <a
            href="tel:010-2684-4892"
            className="inline-flex items-center gap-2 lg:gap-3 bg-blue-500 hover:bg-blue-400 text-white font-bold text-base lg:text-lg px-6 lg:px-8 py-3.5 lg:py-4 rounded-full transition-all cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 lg:w-6 h-5 lg:h-6 flex items-center justify-center">
              <i className="ri-phone-fill text-lg lg:text-xl" />
            </span>
            010-2684-4892
          </a>
        </div>
      </div>
    </section>
  );
}
